import { Provider } from "@angular/core";

import { traducciones } from "../locale/traducciones";
import { condiciones, operadores, procesoDatosProviders } from "./clases";
import {
    CondicionesToken,
    GoogleApiKeyToken,
    GoogleClientIdToken,
    HostToken,
    OperadoresToken,
    PreguntaTipoToken,
    TipoModelToken,
    TraduccionesToken
} from "./tokens";
import { notificacionProviders } from "./services";
import { providersUtils } from "./utils/providersUtils";
import { tiposModelMap, tiposPreguntaMap } from "./maps";
import {
    ProcesoRespuestasProviders
} from "./clases/Investigacion/Respuestas/ProcesoRespuestas/ProcesoRespuestasProviders";
import { ExportadorEncuestasExcel } from "@shared/serviciosExcel";
import { ExportadorEncuestasExcelImpl } from "@shared/serviciosExcel/ExportadorEncuestasExcelImpl";
import { providersExportador } from "./clases/exportador/providersExportador";
import { providersImportador } from "./clases/importador/providersImportador";
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { BarraDateParserFormatter } from "./clases/formatters/BarraDateParserFormatter";
import { GoogleSpreadsheetService } from "./services/google-spreadsheet/google-spreadsheet.service";

export const providers: Provider[] = [
    { provide: OperadoresToken, useValue: operadores },
    { provide: CondicionesToken, useValue: condiciones },
    ...notificacionProviders,
    { provide: TraduccionesToken, useValue: traducciones },
    { provide: PreguntaTipoToken, useValue: tiposPreguntaMap },
    { provide: TipoModelToken, useValue: tiposModelMap },
    ...procesoDatosProviders,
    ...providersUtils,
    { provide: HostToken, useFactory: () => window.location.host },
    ...ProcesoRespuestasProviders,
    ...providersExportador,
    ...providersImportador,
    { provide: GoogleApiKeyToken, useValue: "AIzaSyCVbACKywIxEDG3witPB4DnB1JDnhjcNVk" },
    { provide: GoogleClientIdToken, useValue: "443713377084-jha49ibb7o87btibiidf0o2c83v49tql.apps.googleusercontent.com" },
    { provide: ExportadorEncuestasExcel, useClass: ExportadorEncuestasExcelImpl },
    { provide: NgbDateParserFormatter, useClass: BarraDateParserFormatter },
    GoogleSpreadsheetService
];
